import {createAction, props} from '@ngrx/store';
import {MappedHttpErrorResponse} from '@adnova/jf-ng-components';


export class DatevWizardExportDateActions {

  private static readonly prefix = '[Datev Wizard Export Date]';

  public static setExportDate = createAction(
    `${this.prefix} Set export date`,
    props<{
      exportDate?: string,
    }>(),
  );

  public static setExportDateIndependent = createAction(
    `${this.prefix} Set export date independent`,
    props<{
      exportDateIndependent?: boolean,
    }>(),
  );

  /**
   * Initiiert die Verbindung zu DATEV.
   * Sammelt alle benötigten Daten aus dem Store und ruft die API auf.
   */
  public static readonly connectToDatev = createAction(
    `${this.prefix} Connect to DATEV`,
  );

  /**
   * Wird aufgerufen, wenn die Verbindung erfolgreich hergestellt wurde.
   * Enthält die Login-URL für die Weiterleitung.
   */
  public static readonly connectToDatevSuccess = createAction(
    `${this.prefix} Connect to DATEV Success`,
    props<{
      loginUrl: string;
    }>(),
  );

  /**
   * Wird aufgerufen, wenn beim Verbinden ein Fehler aufgetreten ist.
   */
  public static readonly connectToDatevFailure = createAction(
    `${this.prefix} Connect to DATEV Failure`,
    props<{
      error: MappedHttpErrorResponse;
    }>(),
  );

  /**
   * Navigiert zurück zur Client-ID Seite.
   */
  public static readonly goToClientId = createAction(
    `${this.prefix} Go to Client ID`,
    props<{
      firmenId: string;
    }>(),
  );

  /**
   * Action zum Zurücksetzen des Export-Datums.
   * Wird nach dem Löschen einer Konfiguration aufgerufen.
   */
  public static readonly resetExportDate = createAction(
    `${this.prefix} Reset export date`,
  );

}
